import React from 'react';
import style from './style.module.scss';

export const Logo = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 298.03 47.18"
        {...props}
      >
        <title>OVHcloud_master_logo_white_RGB</title>
        <path
          className={style.logo_cls_1}
          d="M107.11,40.81a40.1,40.1,0,0,1-3.74,44.49H81.93l6.6-11.67H79.8L90.09,55.48h8.78l8.24-14.67ZM64.77,85.3H42.91a39.59,39.59,0,0,1-3.79-44.59L53.3,65.34,68.93,38.12h23L64.78,85.28h0v0Z"
          transform="translate(-33.97 -38.12)"
        />
        <path
          className={style.logo_cls_2}
          d="M125.18,62.4c0-12.59,6.27-18.64,16.57-18.64s16.56,6.05,16.56,18.64S152,81,141.75,81,125.18,74.87,125.18,62.4Zm3.72,0c0,10.35,4.72,15.28,12.85,15.28s12.84-4.93,12.84-15.28-4.72-15.35-12.84-15.35S128.9,52,128.9,62.4Z"
          transform="translate(-33.97 -38.12)"
        />
        <path
          className={style.logo_cls_2}
          d="M185.38,45.25a1.82,1.82,0,0,1,1.7-1.17,1.79,1.79,0,0,1,1.8,1.81,2.42,2.42,0,0,1-.16.79L176.3,79.43a1.78,1.78,0,0,1-3.39,0L160.49,46.68a2.42,2.42,0,0,1-.16-.79,1.79,1.79,0,0,1,1.8-1.81,1.82,1.82,0,0,1,1.7,1.17L174.6,73.81Z"
          transform="translate(-33.97 -38.12)"
        />
        <path
          className={style.logo_cls_2}
          d="M196.42,63.56V78.85a1.81,1.81,0,1,1-3.61,0v-33a1.81,1.81,0,1,1,3.61,0V60.27H214.9V45.89a1.81,1.81,0,1,1,3.61,0v33a1.81,1.81,0,1,1-3.61,0V63.56Z"
          transform="translate(-33.97 -38.12)"
        />
        <path
          className={style.logo_cls_2}
          d="M235.55,55.39a10,10,0,0,1,8.17,3.66,1.56,1.56,0,0,1,.37,1,1.51,1.51,0,0,1-1.54,1.54,1.56,1.56,0,0,1-1.27-.64,6.8,6.8,0,0,0-5.73-2.49c-4.89,0-7.49,3.13-7.49,9.66s2.6,9.71,7.49,9.71a9.68,9.68,0,0,0,6.15-2.28,1.56,1.56,0,0,1,1-.37,1.54,1.54,0,0,1,1.54,1.54,1.63,1.63,0,0,1-.69,1.32,12.06,12.06,0,0,1-8,2.87c-6.85,0-10.94-4.09-10.94-12.79S228.7,55.39,235.55,55.39Z"
          transform="translate(-33.97 -38.12)"
        />
        <path
          className={style.logo_cls_2}
          d="M252.48,44.13V74.45c0,2.12.69,3,2.12,3a1.6,1.6,0,1,1,0,3.19c-3.55,0-5.52-2.13-5.52-6.21V44.13a1.74,1.74,0,0,1,1.7-1.69A1.7,1.7,0,0,1,252.48,44.13Z"
          transform="translate(-33.97 -38.12)"
        />
        <path
          className={style.logo_cls_2}
          d="M281.41,68.13c0,8.7-4.25,12.79-11.15,12.79s-11.14-4.09-11.14-12.79,4.3-12.74,11.14-12.74S281.41,59.42,281.41,68.13Zm-3.45,0c0-6.69-2.81-9.66-7.7-9.66s-7.69,3-7.69,9.66,2.81,9.71,7.69,9.71S278,74.92,278,68.13Z"
          transform="translate(-33.97 -38.12)"
        />
        <path
          className={style.logo_cls_2}
          d="M289.59,57.41V71.26c0,3.45,1.11,6.42,6.47,6.42s6.48-3,6.48-6.42V57.41a1.72,1.72,0,0,1,1.75-1.7,1.67,1.67,0,0,1,1.65,1.7V71.26c0,5-1.65,9.66-9.88,9.66s-9.87-4.62-9.87-9.66V57.41a1.67,1.67,0,0,1,1.7-1.7A1.71,1.71,0,0,1,289.59,57.41Z"
          transform="translate(-33.97 -38.12)"
        />
        <path
          className={style.logo_cls_2}
          d="M328.6,58.84V44.13a1.7,1.7,0,0,1,3.4,0V70.46c0,7-4.35,10.46-10.4,10.46-6.85,0-10.89-4.09-10.89-12.79s3.83-12.74,10.67-12.74A9,9,0,0,1,328.6,58.84Zm0,4.3s-2-4.67-7-4.67-7.49,3.13-7.49,9.66,2.6,9.71,7.49,9.71c4.08,0,7-2.33,7-7.38Z"
          transform="translate(-33.97 -38.12)"
        />
      </svg>
    </>
  );
};
